<div class="checkbox-list-container" *ngFor="let statItem of filter.statistics.values;let i =index">
    <div *ngIf="filter.statsType=='discrete'" class="Flexbox flex-wrap-wrap">
        <div class="Flexbox Flexbox__flex-1">
            <div class="checkbox-custom-container">
                <input type="checkbox" id="{{'checkBox' + i + ' ' + filter.name}}" class="checkbox-custom"
                       name="selected"

                       (click)="updateSelection($event, statItem.value);" [(ngModel)]="statItem.isSelected">
                <label for="{{'checkBox' + i + ' ' + filter.name}}" class="labelDimensions"></label>
            </div>


            <div class="tooltip-container" genTooltip
                 [tooltipPosition]="'RIGHT'" tooltipText="{{statItem.value}}" [appendToBody]="true" tooltipShow="true">
                {{statItem.text | translate}}
            </div>

        </div>
        <div class="dynamic-width-container">
            <gen-dynamic-width [stat]="statItem" [isSelected]="statItem.isSelected"
                               [filter]="filter"></gen-dynamic-width>
        </div>
        <div class="Flexbox Flexbox__flex-1 Flexbox__just-end statValue fs8" [ngClass]="{qtyActive:statItem.isSelected}">
            <span class="Spacebox__l-medium Spacebox__r-small ">{{statItem.qty}}</span>
        </div>
    </div>
</div>
